import React, { useEffect, useRef, useState } from 'react';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import { Point } from '../../../service/types/types';

type GMapSelectorProps = {
  onSelect: (location: Point) => void;
  initialCenter?: Array<number>;
  isReadOnly?: boolean;
};

export const GMapSelector: React.FC<GMapSelectorProps> = ({ onSelect, initialCenter, isReadOnly=false }) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: 'AIzaSyDTiMZJ1AgeaWmarG9pIpnHsLSCy10unuk',
    libraries: ['places'],
  });
  const [marker, setMarker] = useState<{ lat: number; lng: number } | null>(null);
  const [center, setCenter] = useState({ lat: -36.606, lng: -72.102 });
  const mapRef = useRef<google.maps.Map | null>(null);
  const autocompleteContainerRef = useRef<HTMLDivElement>(null);
  
  useEffect( () => {
    if(initialCenter) setCenter({ lat: initialCenter[1], lng: initialCenter[0]});
    if(initialCenter) setMarker({ lat: initialCenter[1], lng: initialCenter[0]});
    if (!isLoaded || !autocompleteContainerRef.current) return;
    const el = document.createElement('gmp-place-autocomplete');
    el.setAttribute('placeholder', 'Buscar ubicación…');
    el.style.width = '100%';
    el.style.padding = '8px';
    el.style.marginBottom = '8px';
    
    el.addEventListener('gmp-select', async (event: any) => {
      const prediction = event.placePrediction;
      if (mapRef.current) {
        //const coords = await getLatLngFromPrediction(prediction.placeId, mapRef.current);
        const coords: any = new google.maps.places.Place({
          id: prediction.placeId, // 👈 el placeId de tu AutocompletePrediction
          requestedLanguage: 'es',              // opcional
          requestedRegion: 'cl',                // opcional
        });
        const a = await coords.fetchFields({ fields: ['location'] });

        if (coords.location) {
          const lat1 = coords.location.lat();
          const lng1 = coords.location.lng();
          console.log("Lat/Lng:", lat1, lng1);
          const { lat, lng } = {lat:lat1, lng:lng1}

          // ✅ Actualiza el centro del mapa
          setCenter({ lat, lng });
          setMarker({ lat, lng });

          // ✅ Guarda en tu DTO
          onSelect({ type: 'Point', coordinates: [lng, lat] });
        }
      }
  });
    autocompleteContainerRef.current.appendChild(el);
  }, [isLoaded]);

  

  function getLatLngFromPrediction(
    placeId: string,
    map: google.maps.Map
  ): Promise<{ lat: number; lng: number } | null> {
    return new Promise((resolve, reject) => {
      const service = new google.maps.places.PlacesService(map);

      service.getDetails(
        {
          placeId: placeId,
          fields: ["geometry"], // 👈 pedimos solo la geometría
        },
        (place, status) => {
          if (
            status === google.maps.places.PlacesServiceStatus.OK &&
            place?.geometry?.location
          ) {
            resolve({
              lat: place.geometry.location.lat(),
              lng: place.geometry.location.lng(),
            });
          } else {
            resolve(null);
          }
        }
      );
    });
  }

  if (!isLoaded) return <div>Cargando mapa...</div>;

  return (
    <div>
      <div ref={autocompleteContainerRef} />
      <GoogleMap
        mapContainerStyle={{ width: '100%', height: '400px' }}
        center={center}  
        zoom={ isReadOnly ? 10 : 14}
        onLoad={(map) => {
          mapRef.current = map;
        }}
        onClick={(e) => {
          if (isReadOnly || !e.latLng) return;
          const lat = e.latLng.lat();
          const lng = e.latLng.lng();
          setMarker({ lat, lng });
          onSelect({ type: 'Point', coordinates: [lng, lat] });
        }}
      >
        {marker && <Marker position={marker} />}
      </GoogleMap>
      </div>
  );
};